import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import Page from '../components/templates/Page/Page';
import DetailShell from './DetailShell';
import DetailTabContent from './DetailTabContent';
import {
  findDetailPageByPathname,
  normalizeDetailPage,
} from '../domain/detail/detailRouteUseCase';

/**
 * Layout route for detail pages. The shell (header + tabs) stays mounted across tab
 * navigation, while the tab content remounts (keyed by path) so each tab shows a clean
 * loading state instead of the previous tab's stale content.
 * @param {object} props
 * @param {ApiPage[]} props.pages
 * @returns {JSX.Element | null}
 */
function DetailLayout({ pages }) {
  const location = useLocation();
  const [isTabTransitioning, setIsTabTransitioning] = useState(false);

  const matchedPage = findDetailPageByPathname(pages, location.pathname);
  if (!matchedPage) return null;

  const page = normalizeDetailPage(matchedPage);

  return (
    <Page page={page}>
      <DetailShell
        page={page}
        isTabTransitioning={isTabTransitioning}
        setIsTabTransitioning={setIsTabTransitioning}
      />
      <DetailTabContent
        key={page.path}
        page={page}
        isLoading={isTabTransitioning}
      />
    </Page>
  );
}

export default DetailLayout;
